import React from 'react';
import './footer.css';
import 'font-awesome/css/font-awesome.min.css';


<div className="footer-section social-media">
  <h2>Follow Us</h2>
  <div className="social-icons">


    <a href="" className="social-icon"><i className="fa fa-linkedin"></i></a>

   
  </div>
</div>


function  FooterComp() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section quick-links">
          <h2>Quick Links</h2>
          <ul>
          <li><a href="/">Home</a></li>
         
          {/* <li><a href="/sponsorAmount">Sponsor</a></li> */}
          <li><a href="/upcomingevent">Upcoming Event</a></li>
            <li><a href="/aboutus">About Us</a></li>
            <li><a href="/contactus">Contact Us</a></li>
            <li><a href="/signin">Login</a></li>
            <li><a href="https://optometryassociation.lk" className="text text-decoration-none" target="_blank" rel="noopener noreferrer">Ceylon Eye Care Optometric Association</a></li>
          </ul>
        </div>

        <div className="footer-section quick-links">
          <h2>Information</h2>
          <ul>
            <li><a href="/faqs">FAQs</a></li>
            <li><a href="/termsandconditions"> Terms & Conditions</a></li>
            <li><a href="/privacyandpolicies">Privacy & Policies</a></li>
            <li><a href="/refundpolicy">Refund Policies</a></li>
          </ul>
        </div>

        <div className="footer-section contact">
          <h2>Contact Us</h2>
          <p>Email: <a href="mailto:ecinstitute@gmail.com">ecinstitute@gmail.com</a> <br />
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<a href="mailto:info@eyecare2027.com">info@eyecare2027.com</a>
          </p>
        

          <p>Phone: +94 77 344 0937</p>
          <p>Location: 932, Maradana Road, Colombo 08, Sri Lanka.</p>
        </div>
        <div className="footer-section social-media">
          <h2>Follow Us</h2>
          <div className="social-icons">
          <a href="https://web.facebook.com/profile.php?id=61573057572352" 
              target="_blank"
              rel="noopener noreferrer" 
              className="social-icon"><i className="fa fa-facebook"></i></a>


            {/* <a href="https://www.linkedin.com/company/eye-care-institute-%E2%80%93-vision-health-education/" 
               target="_blank"
               rel="noopener noreferrer" 
            className="social-icon linkedin">
                <i className="fa fa-linkedin"></i>
            </a> */}

            <a href="https://www.instagram.com/eyecareinstitutesl?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"><i className="fa fa-instagram"></i></a>

            <a href="https://www.youtube.com/@eyecareinstitutesrilanka8780" 
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"><i className="fa fa-youtube"></i></a>
          </div>
        
        </div>
      </div>
      <div className="footer-bottom">
<p>
 &copy; 2026 &nbsp;  E Y E &nbsp; C A R E &nbsp; 2 0 2 7 &nbsp; - &nbsp; SAARC Optometry Conference. All rights reserved. | 
  Designed and Developed by 
  <a 
    className="glaxmore-link" 
    href="https://www.glaxmore.com" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    &ensp; GLAXMORE
  </a>
</p>
      </div>
    </footer>
  )
}

export default FooterComp

